// @flow

import React, { Component } from 'react';
import TextField from 'material-ui/TextField';
import FlatButton from 'material-ui/FlatButton';
import {Tabs, Tab} from 'material-ui/Tabs';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import Alert from 'react-s-alert';
import _ from 'lodash';

import TreeUser from './TreeUser.jsx';
import UserDirs from './UserDirs.jsx';
import App from './App.jsx';
import SelectUser from './SelectUser.jsx';

import {no_rclick, removable, path_is_inside} from './utils.js';
import Role from './roles.js';
import {ROOT_DIR} from './consts.js';

import type {T_Role} from './roles.js';
import type {T_User} from './types.js';

import './css/DialogUser.css';

const validator = require("email-validator"),
      moment    = require('moment');

require('moment/locale/es');



type T_DialogUserProps = {
  window_drag   : boolean,
  show_titles   : boolean,
  width         : number,
  height        : number,
  create_mode   : boolean,
  show_restore? : boolean,
  edit_roles?   : boolean,
  edit_dirs     : boolean,                       // en modo creación, este props se ignora. En edición: ¿se deben editar las carpetas del usuario?
  only_edit_dirs: boolean,                       // en modo creación, este props se ignora. En edición: ¿se pueden editar el nombre real, el email y las password?
  the_user      : T_User,                        // en modo creación, pasar EMPTY_USER. En modo edición, pasar un usuario existente.
  proceed       : (user: ?T_User) => void,       // acción que se ejecutará cuando al apretar el botón de acción. Si user es null, el diálogo tuvo un error y faltan datos.
  remove_user?  : (user_name: string) => void,   // acción que se ejecutará al apretar el botón borrar. Este prop automáticamente muestra el botón borrar.
  cancel?       : () => void,                    // acción que se ejecutará al cancelar.
  father_select?: SelectUser,
  app           : App,
  top?          : number,
  left?         : number
};


type T_DialogUserState = {
  user        : T_User,     // el usuario que se está manipulando actualmente.
  new_pass2   : string,     // password de validación.
  mode_true   : boolean,    // ¿qué set de directorios está activo? ¿true_dirs o black_dirs?
  exists_error: string,
  email_error : string,
  pass_error  : string,
  name_error  : string,
  tdir_error  : string,
  role_error  : string,
  top         : number,
  left        : number,
  reveal_pass : boolean
};



export default class DialogUser extends Component<T_DialogUserProps, T_DialogUserState> {
  original_user  : T_User;
  created_at     : string;
  cls_name       : string;
  
  tree_user      : ?TreeUser;
  
  mode_black_dirs : () => void;
  mode_true_dirs  : () => void;
  change_nombre   : (ev: SyntheticInputEvent<*>) => void;
  change_email    : (ev: SyntheticInputEvent<*>) => void;
  change_pass1    : (ev: SyntheticInputEvent<*>) => void;
  change_pass2    : (ev: SyntheticInputEvent<*>) => void;
  change_role     : (event: Event, index: number, value: T_Role) => void;
  call_proceed    : (ev: SyntheticMouseEvent<*>) => void;
  call_remove_user: (ev: SyntheticMouseEvent<*>) => void;
  restore_user    : () => void;
  reveal_pass     : () => void;
  
  
  
  constructor(props: T_DialogUserProps) {
    super(props);
    
    this.created_at    = moment();
    this.cls_name      = `dlguser-${`${Math.random()}`.slice(2)}`;
    this.original_user = _.cloneDeep(this.props.the_user);
    
    this.state = {
      user        : _.cloneDeep(this.props.the_user),
      new_pass2   : _.cloneDeep(this.props.the_user.pass),
      mode_true   : true,
      exists_error: '',
      email_error : '',
      pass_error  : '',
      name_error  : '',
      tdir_error  : '',
      role_error  : '',
      top         : this.props.top  != null ? this.props.top  : -1,
      left        : this.props.left != null ? this.props.left : -1,
      reveal_pass : false
    };
    
    this.mode_black_dirs  = this.mode_black_dirs.bind(this);
    this.mode_true_dirs   = this.mode_true_dirs.bind(this);
    this.change_nombre    = this.change_nombre.bind(this);
    this.change_email     = this.change_email.bind(this);
    this.change_pass1     = this.change_pass1.bind(this);
    this.change_pass2     = this.change_pass2.bind(this);
    this.change_role      = this.change_role.bind(this);
    this.call_proceed     = this.call_proceed.bind(this);
    this.call_remove_user = this.call_remove_user.bind(this);
    this.restore_user     = this.restore_user.bind(this);
    this.reveal_pass      = this.reveal_pass.bind(this);
  }
  
  
  
  get_user(): T_User {
    const user = _.cloneDeep(this.state.user);
    
    user.true_exists = _.cloneDeep(user.true_dirs);
    
    return user;
  }
  
  
  
  componentDidMount() {
    if (this.props.father_select != null) {
      this.props.father_select.dialog_user = this;
    }
    
    if (this.props.app.state.user.user_name === this.state.user.user_name) {
      this.props.app.dialog_user_me = this;
    }
    else {
      this.props.app.dialog_user_make = this;
    }
  }
  
  
  
  componentWillUnmount() {
    if (this.props.father_select != null) {
      this.props.father_select.dialog_user = null;
    }
    
    if (this.props.app.state.user.user_name === this.state.user.user_name) {
      this.props.app.dialog_user_me = null;
    }
    else {
      this.props.app.dialog_user_make = null;
    }
  }
  
  
  
  componentDidUpdate(prevProps: T_DialogUserProps, prevState: T_DialogUserState) {
    if (this.state.user.true_dirs.length > 0 && this.state.tdir_error) {
      this.setState({tdir_error: ''});
    }
  }
  
  
  
  has_errors(): boolean {
    return (
      (! validator.validate(this.state.user.email))           ||
      (this.state.user.pass !== this.state.new_pass2)         ||
      (! this.state.user.real_name)                           ||
      (this.state.user.role === '')                           ||
      (this.state.user.role === 'Unknown')                    ||
      (this.state.user.true_dirs.filter(removable).length === 0)
    );
  }
  
  
  
  set_errors(): void {
    if (moment().diff(this.created_at) < 500) {
      return;
    }
    
    const new_state = {email_error: '', pass_error: '', name_error: '', tdir_error: '', role_error: ''};
    
    if (! validator.validate(this.state.user.email)) {
      new_state.email_error = 'Email incorrecto';
    }
    
    if (this.state.user.pass !== this.state.new_pass2) {
      new_state.pass_error = 'Las contraseñas no coinciden';
    }
    
    if (! this.state.user.real_name) {
      new_state.name_error = 'Nombre incorrecto';
    }
    
    if (this.props.create_mode && (this.state.user.role === '' || this.state.user.role === 'Unknown')) {
      new_state.role_error = 'Configure un rol al nuevo usuario';
    }
    
    if (this.props.edit_dirs && this.state.user.true_dirs.filter(removable).length === 0) {
      new_state.tdir_error = '(Agregue alguna carpeta para guardar)';
    }
    
    this.setState(new_state);
  }
  
  
  
  check_username_exist(): void {
    if (this.props.create_mode && this.state.user.user_name !== '') {
      const {app} = this.props,
            url   = `${app.remote}/user-name-exist/?user_name=${this.state.user.user_name}&session_id=${app.session()}`;
      
      fetch(url).then(resp => resp.json()).then((response: string | boolean) => {
        if (typeof response === 'boolean') {
          this.setState({
            exists_error: (response === true ? 'El usuario ya existe' : '')
          });
        }
      });
    }
  }
  
  
  
  change_nombre(ev: SyntheticInputEvent<*>): void {
    const user = this.get_user();
    
    user.real_name = ev.target.value;
    
    if (this.props.create_mode) {
      user.user_name = ev.target.value.split(' ').filter(_.identity).slice(0, 2).map(xx => xx.toLowerCase()).join('.');
    }
    
    this.setState({user}, () => {
      this.set_errors();
      this.check_username_exist();
    });
  }
  
  
  
  change_email(ev: SyntheticInputEvent<*>): void {
    const user = this.get_user();
    
    user.email = ev.target.value;
    
    this.setState({user}, () => this.set_errors());
  }
  
  
  
  change_pass1(ev: SyntheticInputEvent<*>): void {
    const user = this.get_user();
    
    user.pass = ev.target.value;
    
    this.setState({user}, () => this.set_errors());
  }
  
  
  
  change_pass2(ev: SyntheticInputEvent<*>): void {
    this.setState({new_pass2: ev.target.value}, () => this.set_errors());
  }
  
  
  
  mode_black_dirs(): void {
    this.setState({mode_true: false});
  }
  
  
  
  mode_true_dirs(): void {
    this.setState({mode_true: true});
  }
  
  
  
  change_role(event: Event, index: number, value: T_Role): void {
    const user = this.get_user();
    
    user.role = value;
    
    this.setState({user, role_error: ''});
  }
  
  
  
  add_editing_dir(path: string): void {
    const other   = this.state.mode_true ? this.state.user.black_dirs : this.state.user.true_dirs,
          ROOT    = `${ROOT_DIR}/`,
          is_root = path === ROOT;
    
    const add = (list) => {
      const user = this.get_user();
      
      list.push(path);
      
      if (this.state.mode_true) {
        user.true_dirs = list;
      }
      else {
        user.black_dirs = list;
      }
      
      this.setState({user});
    };
    
    const is_subdir = list => _.some(list, dir => path_is_inside(path, dir));
    
    if (! _.includes(other, path)) {
      const list = _.cloneDeep(this.state.mode_true ? this.state.user.true_dirs : this.state.user.black_dirs);
      
      if ((! _.includes(list, path)) && (! is_subdir(list))) {
        if (this.state.mode_true) {
          if (! ((is_root && list.length > 0) || (list.length > 0 && list[0] === ROOT))) {
            add(list);
          }
        }
        else {
          if (! is_root) {
            add(list);
          }
        }
      }
    }
  }
  
  
  
  remove_editing_dir(path: string): void {
    const list     = this.state.mode_true ? _.cloneDeep(this.state.user.true_dirs) : _.cloneDeep(this.state.user.black_dirs),
          new_list = _.filter(list, dir => dir !== path),
          user     = this.get_user();
    
    if (this.state.mode_true) {
      user.true_dirs = new_list;
    }
    else {
      user.black_dirs = new_list;
    }
    
    this.setState({user});
  }
  
  
  
  call_proceed(ev: SyntheticMouseEvent<*>): void {
    if (ev.button === 0) {
      this.props.proceed(this.has_errors() ? null : this.get_user());
    }
  }
  
  
  
  call_remove_user(ev: SyntheticMouseEvent<*>): void {
    if (ev.button === 0) {
      const user = this.get_user(),
            me   = this.props.app.state.user;
      
      if (this.props.remove_user && _.isFunction(this.props.remove_user)) {
        const {remove_user} = this.props;
        
        if (Role.status(me.role) > Role.status(user.role)) {
          remove_user(user.user_name);
        }
        else {
          Alert.error(`${user.user_name} tiene mayor estatus que tú.`);
        }
      }
      else {
        console.error('DialogUser.props.remove_user no es una función.');
      }
    }
  }
  
  
  
  restore_user(): void {
    this.setState({user: _.cloneDeep(this.original_user)});
  }
  
  
  
  reveal_pass(): void {
    this.setState({reveal_pass: ! this.state.reveal_pass});
  }
  
  
  
  render() {
    const style              = {},
          {app}              = this.props,
          tab_sty            = {textTransform: 'none', padding: 0},
          show_head          = ! this.props.create_mode,
          my_status          = Role.status(app.state.user.role),
          this_user_status   = Role.status(this.state.user.role),
          editing_my_account = app.state.user.user_name === this.state.user.user_name,
          editing_my_son     = (! editing_my_account) && my_status > this_user_status,
          can_reveal_pass    = editing_my_account || editing_my_son || app.agrosat_user,
          god_mode           = app.god_mode(),
          fontTitle          = app.favorite_font_title();
    
    // console.log('user_name         ', this.state.user.user_name);
    // console.log('my_status         ', my_status);
    // console.log('this_user_status  ', this_user_status);
    // console.log('editing_my_account', editing_my_account);
    // console.log('editing_my_son    ', editing_my_son);
    // console.log('can_reveal_pass   ', can_reveal_pass);
    
    if (this.props.height != null && typeof this.props.height === 'number' && this.props.height < 760) {
      style.top = Math.max(50, 150 - Math.abs(this.props.height - 760));
    }
    
    const style_form = {};
    
    if (this.props.create_mode) {
      style_form.borderTop = '2px solid lightgray';
    }
    
    if (this.state.top !== -1 && this.state.left !== -1) {
      style.top  = this.state.top;
      style.left = this.state.left;
    }
    
    return (
      <div>
        {this.props.edit_dirs &&
          <TreeUser
            name={this.state.user.real_name}
            height={this.props.height}
            app={this.props.app}
            dialog_user={this}
            top_dirs={
              app.agrosat_user ?
                [ROOT_DIR]
              :
                (editing_my_son ? app.state.user.true_dirs : this.state.user.true_dirs)
            }
            black_dirs={editing_my_son ? app.state.user.black_dirs : []}
          />
        }
        
        <div className={this.props.height >= 850 ? `userpop ${this.cls_name}` : `userpop2 ${this.cls_name}`} onContextMenu={no_rclick} style={style}>
          {this.props.create_mode &&
            <div className='du_create_mode'>
              Crear nuevo usuario
            </div>
          }
          
          {show_head &&
            <div className='user_role_div' style={{fontFamily: fontTitle, textTransform: god_mode ? 'uppercase' : 'none'}}>
              <center>
                {Role.friendly_name(this.state.user.role)}
              </center>
            </div>
          }

          <div className='user_forms' style={style_form}>
            {this.props.show_titles &&
              <div className='title_datos'>
                <p>Datos de la cuenta</p>
              </div>
            }
            
            <TextField
              floatingLabelText='Nombre'
              value={this.state.user.real_name}
              errorText={this.state.name_error}
              onChange={this.change_nombre}
              disabled={this.props.only_edit_dirs}
            />
            
            <br />
            
            {this.props.create_mode &&
              <div>
                <TextField
                  floatingLabelText='Nombre de usuario'
                  value={this.state.user.user_name}
                  errorText={this.state.exists_error}
                  disabled={true}
                />
                
                <br />
              </div>
            }
            
            <TextField
              floatingLabelText='Email'
              value={this.state.user.email}
              errorText={this.state.email_error}
              onChange={this.change_email}
              disabled={this.props.only_edit_dirs}
            />
            
            {(! this.props.only_edit_dirs) && 
              <div>
                {this.props.show_titles &&
                  <p style={{textAlign: 'center', margin: 0, marginTop: 10}}>Cambiar contraseña</p>
                }
                
                <table className='main_pass'>
                  <tbody>
                    <tr>
                      <td>
                        <TextField
                          style={{width: 180}}
                          floatingLabelText='Contraseña'
                          value={this.state.user.pass}
                          type='password'
                          errorText={this.state.pass_error}
                          onChange={this.change_pass1}
                        />
                      </td>
                      
                      <td>
                        {can_reveal_pass &&
                          <div>
                            <button className='du_reveal' onClick={this.reveal_pass}>
                              {this.state.reveal_pass ? 'ocultar' : 'revelar'}
                            </button>
                            
                            <br />
                            
                            <span className='du_reveal'>
                              {this.state.reveal_pass ? this.state.user.pass : <span>&nbsp;</span>}
                            </span>
                          </div>
                        }
                      </td>
                    </tr>
                  </tbody>
                </table>
                
                <br />
                
                <TextField
                  floatingLabelText='Confirmar contraseña'
                  value={this.state.new_pass2}
                  type='password'
                  errorText={this.state.pass_error}
                  onChange={this.change_pass2}
                />
                
                <br />
              </div>        
            }
            
            {(this.props.create_mode || this.props.edit_roles) &&
              <div>
                <SelectField floatingLabelText='Rol' value={this.state.user.role} onChange={this.change_role} autoWidth={true}>
                  {_.sortBy(Role.known.filter(rol => Role.status(rol) < my_status), rol => Role.status(rol))
                    .map((role: T_Role, num: number) => {
                    if ((app.state.user.role === Role.coordinador && role !== Role.coordinador) || (app.props.user.role !== Role.coordinador)) {
                      const role_name: string = Role.friendly_name(role);
                      
                      return (
                        <MenuItem key={num} value={role} primaryText={role_name} />
                      );
                    }
                    return false;
                  })}
                </SelectField>
                
                <p className='tdir_error'>{this.state.role_error}</p>
              </div>
            }
            
            {this.props.edit_dirs &&
              <div className='user_dirs'>
                <Tabs tabItemContainerStyle={{backgroundColor: 'white'}}>
                  <Tab label='Carpetas asignadas' style={tab_sty} onActive={this.mode_true_dirs}>
                    <div className='user_dir_links'>
                      <p className='tdir_error'>{this.state.tdir_error}</p>
                      
                      <UserDirs
                        list={this.state.user.true_dirs}
                        forbid_root={false}
                        dialog_user={this}
                      />
                    </div>
                  </Tab>
                  
                  <Tab label='Carpetas omitidas' style={tab_sty} onActive={this.mode_black_dirs}>
                    <div className='user_dir_links'>
                      <UserDirs
                        list={this.state.user.black_dirs}
                        forbid_root={true}
                        dialog_user={this}
                      />
                    </div>
                  </Tab>
                </Tabs>
              </div>
            }
            
            <div className='user_dirs_bts'>
              {this.props.remove_user != null &&
                <FlatButton
                  label='Borrar'
                  primary={true}
                  onContextMenu={no_rclick}
                  onClick={this.call_remove_user}
                  style={{marginRight: 10}}
                />
              }
              
              {(this.props.cancel != null) &&
                <FlatButton
                  label='Cancelar'
                  primary={true}
                  onContextMenu={no_rclick}
                  onClick={this.props.cancel}
                  style={{marginRight: 10}}
                />
              }
              
              {this.props.show_restore &&
                <FlatButton
                  label='Restaurar'
                  primary={true}
                  onContextMenu={no_rclick}
                  onClick={this.restore_user}
                  style={{marginRight: 10}}
                />
              }
              
              <FlatButton
                label={this.props.create_mode ? 'Crear' : 'Guardar'}
                primary={true}
                onContextMenu={no_rclick}
                onClick={this.call_proceed}
                backgroundColor='#357bb8'
                hoverColor='#1e5d92'
                labelStyle={{color: 'white'}}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/DialogUser.jsx